import React from 'react';
import PropTypes from 'prop-types';
import Shimmer from '@lsq/nextgen/v2/shimmer';
import { GridShimmer } from '@lsq/nextgen/v2/grid';
import styles from './styles.module.css';

/**
 * Full-page skeleton for TableListing. Covers the title bar + filter row
 * (composed from the `Shimmer` primitive) and delegates the table skeleton
 * to the library's `GridShimmer`. Rendered while the listing API and the
 * teams-assignment API are in flight — see each listing view's `isFetching`.
 */
const TableListingShimmer = ({ rows = 10, columns = 6 }) => (
  <div className={styles.wrapper} data-testid="table-listing-shimmer">
    <div className={styles.headerRow}>
      <div className={styles.titleGroup}>
        <Shimmer height="1.5rem" width="14rem" />
        <Shimmer height="1.25rem" width="3.5rem" />
      </div>
      <Shimmer height="2.25rem" width="9rem" />
    </div>

    <div className={styles.filterRow}>
      <Shimmer height="2rem" width="12rem" />
    </div>

    <div className={styles.grid}>
      <GridShimmer rows={rows} columns={columns} />
    </div>
  </div>
);

TableListingShimmer.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number
};

export default TableListingShimmer;
